import { Box, ButtonBase, CircularProgress, Divider, Fade, Grid, Link, Menu, MenuItem, Slide, useMediaQuery, useScrollTrigger, useTheme } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { ArrowBack } from '@material-ui/icons';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink, Route, Switch, useHistory } from "react-router-dom";
import { Mixpanel } from '../mixpanel';
import { SYSTEM_ALL_HANDLE } from '../terbebasApi';
import { categoryMap } from 'common-ts/dist/models/CategoryList';
import { ProductCategory } from 'common-ts/dist/models/Product';
import { getNumberOfItems } from '../redux/CartRedux';
import { updateCurrentScreen } from '../redux/UIOverlayNavbarRedux';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import CartWindow from './CartWindow';
import MobileCategoryMenu from './MobileCategoryMenu';
import SearchOverlay from './SearchOverlay';
import SearchIcon from '@material-ui/icons/Search';
import { BannerOngkir } from '../App'
import { setDialogLoadingCategory } from '../redux/UIOverlayFlowVersionRedux';

interface stylesProps {
  textColor: string
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grow: {
      flexGrow: 1,
    },
    title: {
      display: 'block',
      margin: 'auto',
    },
    titleLogoContainer: {
      height: '38px',
      display: 'flex',
      [theme.breakpoints.down('xs')]: {
        height: '34px',
      }
    },
    titleLogoButtonBase: {
      justifyContent: 'flex-start', // This is required for safari and ios
    },
    titleLogo: {
      height: '100%',
      display: 'block', // We use block so that the img is unique horizontally in the div
      // This is equivalent to #000.
      // [theme.breakpoints.down('xs')]: {
      //   height: '30%',
      // }
    },
    sectionDesktopAndMobile: {
      display: 'flex',
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    shopButton: {
      marginLeft: '24px',
    },
    buttonLinkContainer: {
      display: 'flex',
      paddingRight: '20px',
      [theme.breakpoints.down('xs')]: {
        paddingRight: '6px',
      },
      alignItems: 'center',
      '-webkit-tap-highlight-color': 'transparent',
    },
    buttonLink: {
      margin: 'auto',
      color: '#000',
      fontSize: '14px',
      textDecoration: 'none !important',
    },
    barIcon: {
      color: '#000',
      [theme.breakpoints.down('xs')]: {
        marginLeft: '4px',
        marginRight: '2px',
        padding: '4px'
      }
    },
    barIconArrowBack: {
      color: '#000',
      marginRight: '12px',
      [theme.breakpoints.down('xs')]: {
        padding: '4px',
        marginRight: '8px',
      }
    },
    appBar: {
      // paddingLeft: '20px',
      // paddingRight: '20px',
      // [theme.breakpoints.down('xs')]: {
      //   paddingLeft: '6px',
      //   paddingRight: '6px',
      // },
    },
    internalToolbarGrid: {
      paddingLeft: '20px',
      paddingRight: '20px',
      [theme.breakpoints.down('xs')]: {
        paddingLeft: '6px',
        paddingRight: '6px',
      },
    },
    productNavigation: {
      position: 'relative',
      visibility: 'visible',
      // top: '64px',
      height: '60px',
      [theme.breakpoints.down('xs')]: {
        // top: '56px',
        height: '40px',
      },
      left: '0px',
      backgroundColor: 'white',
      width: '100%',
      borderTop: '1px solid #efefef',
      borderBottom: '1px solid #efefef',
      display: 'flex',
      alignItems: 'center',
      overflowX: 'auto',
      overflowY: 'hidden',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    productNavigationContainer:{
      height: '100%',
      textDecoration: 'none',
      display: "flex",
      alignItems: "center",
      WebkitTapHighlightColor: 'rgba(255,255,255,0)',
      '&:hover': {
        textDecoration: 'none',
      }
    },
    productNavigationLeftSpacer: {
      minWidth: '20px',
      height: '10px',
      [theme.breakpoints.down('xs')]: {
        minWidth: '16px',
      },
    },
    productNavigationLinkText: {
      fontFamily: 'OakesGrotesk',
      margin: '3px 0px 0px 0px',
      fontSize: '10.5px',
      whiteSpace: 'nowrap',
      letterSpacing: '1.1px',
      fontWeight: 400,
      display: 'flex',
      height: '100%',
      alignItems: 'center',
    },
    productNavigationLinkTextDisabled: {
      fontFamily: 'OakesGrotesk',
      margin: '3px 0px 0px 0px',
      fontSize: '10.5px',
      whiteSpace: 'nowrap',
      letterSpacing: '1.1px',
      fontWeight: 400,
      display: 'flex',
      height: '100%',
      alignItems: 'center',
      color:'#aaaaaa',
    },
    productNavigationLinkTextSelected: {
      fontFamily: 'OakesGrotesk',
      margin: '3px 0px 0px 0px',
      fontSize: '10.5px',
      whiteSpace: 'nowrap',
      letterSpacing: '1.1px',
      fontWeight: 400,
      display: 'flex',
      height: '100%',
      alignItems: 'center',
      color: "#ffffff",
    },
    productNavigationLinkTextContainer: {
      padding: "0 10px",
      margin: "0 2px",
    },
    productNavigationLinkTextContainerSelected: {
      padding: "0 10px",
      margin: "0 2px",
      backgroundColor: "#2A2A2A",
      borderRadius: "14px",
    },
    leftContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: '100%',
    },
    shopText: {
      fontFamily: 'OakesGrotesk',
      fontWeight: 600,
      fontSize: '11px',
      letterSpacing: "0.8px",
      margin: '1px 3px 0px 0px',
      [theme.breakpoints.only('xs')]: {
        margin: '0px 8px 0px 0px',
      },
      border: '0.9px solid #b0b0b0',
      borderRadius: '50px',
      padding: '4.3px 9px 1.1px 9.5px',
      textDecoration: 'none !important',
    }
  }),
);

const ScrollHandlerAppBar = (props:any) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 20,
  });

  // const triggerMove = useScrollTrigger({ target: window ? window : undefined, threshold: 40 });
  const triggerMove = false;

  const colorAtTop = props.transparentAtTop ? "transparent" : "#ffffff";
  const elevationAtTop = props.transparentAtTop ? 0 : 0;

  const transparency = props.transparent ? "" : "#FFFFFF";

  return (
    <Slide appear={false} direction="down" in={!triggerMove}>
      {React.cloneElement(props.children, {
        color: trigger ? "default" : colorAtTop,
        elevation: trigger ? 0 : elevationAtTop,
        style: {
          transition: trigger ? "0.3s" : "0.5s",
          background: trigger ? "#FFFFFF" : "",
        }
      })}
    </Slide>
  )
};

const ScrollHandlerBarElementColor = (props:any) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 20,
  });

  const topColor = props.coloredAtTop ? "#fff" : "#000";

  return React.cloneElement(props.children, {
    style: {
      color: trigger ? "#000" : topColor,
    }
  });
};

const ScrollHandlerLogo = (props:any) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  let topSize;
  let topMargin;
  let defaultSize = "60%";
  if (props.largerTitleAtTop) {
    if (props.isSmOrUp) {
      topSize = "107%";
      topMargin = "14px";
      defaultSize = "77%";
    } else {
      topSize = "110%";
      topMargin = "10px";
      defaultSize = "80%";
    }
  } else {
    if (props.isSmOrUp) {
      topSize = "77%";
      topMargin = "";
      defaultSize = topSize;
    } else {
      topSize = "77%";
      topMargin = "";
      defaultSize = topSize;
    }
  }

  return React.cloneElement(props.children, {
    style: {
      transition: trigger ? "0.24s" : "0.24s",
      height: trigger ? defaultSize : topSize,
      marginTop: trigger ? "" : topMargin,
    }
  });
}

interface Props {
  transparentAtTop: boolean
  coloredAtTop: boolean
  largerTitleAtTop: boolean
  transparent: boolean
  goBackFunction?: () => void
}

export default function NavBar({transparentAtTop, coloredAtTop, largerTitleAtTop, transparent, goBackFunction}: Props) {
  const dispatch = useAppDispatch();
  const numberOfItemsInCart = useAppSelector(state => getNumberOfItems(state.cart));
  const isLoggedIn = useAppSelector(state => state.account.authState === 'signedin');
  const classes = useStyles();
  const navbarOverlayScreen = useAppSelector(state => state.overlayNavbar.currentScreen)
  // Terbebas: the category bar lists the store's Kategori pages. Stores
  // that haven't defined any fall back to their Koleksi (excluding each
  // category's implicit direct-products Koleksi).
  const collectionsDictionary = useAppSelector(state => state.productsList.collectionsDictionary);
  const efficientCollectionsOrder = useAppSelector(state => state.productsList.efficientCollectionsOrder);
  const categoriesDictionary = useAppSelector(state => state.productsList.categoriesDictionary) ?? {};
  const categoriesOrder = useAppSelector(state => state.productsList.categoriesOrder) ?? [];
  const storeProfile = useAppSelector(state => state.storeProfile.profile);

  // StoreConfig.categoryNavEnabled hides the bar entirely. Its order is
  // always the merchant's manual arrangement, which the backend already
  // returns position-sorted.
  const categoryNavEnabled = (storeProfile?.config as any)?.categoryNavEnabled !== false;

  // The system "Semua Produk" Kategori is rendered as the leading SEMUA chip
  // rather than a regular category chip. It points at /shop — the canonical,
  // shortest URL — which PageProductList now resolves through that very
  // Kategori, so /shop and /shop/category/semua-produk render the same page.
  const semuaChipTarget = "/shop";
  const semuaChipSelectedPaths = [
    "/shop", "/shop/hero/:variantHero", "/shop/landing", "/shop/start",
    "/shop/category/" + SYSTEM_ALL_HANDLE,
  ];

  const navCategories: { handle: string; title: string }[] = categoriesOrder.length
    ? categoriesOrder
      .map((handle) => categoriesDictionary[handle])
      .filter((c) => !!c && c.categoryId !== SYSTEM_ALL_HANDLE)
      .map((c) => ({ handle: c!.categoryId, title: c!.title }))
    : (efficientCollectionsOrder ?? [])
      .map((handle) => collectionsDictionary[handle])
      .filter((c) => c && c.collectionId !== '__all__' && c.collectionId !== SYSTEM_ALL_HANDLE && !c.isDefault)
      .map((c) => ({ handle: c.collectionId, title: c.title ?? c.collectionId }));

  // Optional per-tenant hamburger dropdown (top right). Configured via
  // StoreConfig.theme.navMenu = { enabled, items: NavMenuEntry[] } where an
  // entry is a link ({ label, url }) or a group ({ label, items: entry[] })
  // — groups nest up to 3 levels and collapse/expand in the dropdown.
  const navMenuConfig = ((storeProfile?.config?.theme as any)?.navMenu ?? {}) as {
    enabled?: boolean;
    items?: any[];
  };
  const [navMenuAnchorEl, setNavMenuAnchorEl] = React.useState<null | HTMLElement>(null);
  // Group open-state keyed by dotted path ("0", "0.2", "0.2.1").
  const [navMenuOpenGroups, setNavMenuOpenGroups] = React.useState<{ [path: string]: boolean }>({});
  // Optional per-tenant product search (StoreConfig.theme.searchEnabled).
  const searchEnabled = !!((storeProfile?.config?.theme as any)?.searchEnabled);
  const [searchOpen, setSearchOpen] = React.useState(false);
  const theme = useTheme();
  const isSmOrUp = useMediaQuery(theme.breakpoints.up("sm"));
  const history = useHistory();
  const isInsideIframe = window.self !== window.top;

  const navMenuNavigate = (url: string) => {
    setNavMenuAnchorEl(null);
    setNavMenuOpenGroups({});
    if (url.startsWith('http')) {
      window.open(url, '_blank');
    } else {
      history.push(url);
    }
  };
  // Renders nav entries (links + nestable groups) as a flat list of
  // MenuItems, indented by depth; groups toggle their children in place.
  const renderNavMenuEntries = (entries: any[], pathPrefix: string, depth: number): JSX.Element[] =>
    (entries ?? []).flatMap((item, i) => {
      const path = pathPrefix ? `${pathPrefix}.${i}` : `${i}`;
      const indent = 16 + (depth - 1) * 18;
      if (Array.isArray(item.items) && item.items.length > 0) {
        const isOpen = !!navMenuOpenGroups[path];
        return [
          <MenuItem key={'g' + path} id={'tb-nav-group-' + path} style={{ paddingLeft: indent }}
            onClick={() => setNavMenuOpenGroups({ ...navMenuOpenGroups, [path]: !isOpen })}>
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              {item.label}
              {isOpen ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
            </Box>
          </MenuItem>,
          ...(isOpen ? renderNavMenuEntries(item.items, path, depth + 1) : []),
        ];
      }
      if (!item.url) return [];
      return [
        <MenuItem key={path} style={{ paddingLeft: indent }} onClick={() => navMenuNavigate(item.url)}>
          {item.label}
        </MenuItem>,
      ];
    });

  const handleClickCategory = () => {
    dispatch(setDialogLoadingCategory(true));
    setTimeout(() => {
      dispatch(setDialogLoadingCategory(false));
    }, 2450); 
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 350); 
  }

  return (
    <div className={classes.grow}>
      <ScrollHandlerAppBar transparentAtTop={transparentAtTop} transparent={transparent}>
        <AppBar position="fixed" color="transparent" className={classes.appBar} elevation={0}>
          <BannerOngkir />
          <Toolbar>
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
              wrap="nowrap"
              className={classes.internalToolbarGrid}
            >
              <Grid item xs={6} md={4} className={classes.sectionDesktopAndMobile}>
                <Box className={classes.leftContainer}>
                  <Switch>
                    <Route path="/shop/product/:productId">
                      <ScrollHandlerBarElementColor coloredAtTop={coloredAtTop} >
                        <IconButton
                          className={classes.barIconArrowBack}
                          color="primary"
                          aria-label="open drawer"
                          edge="start"
                          onClick={() => {
                            Mixpanel.track('navigateRoute', {
                              'routePath': '/shop',
                              'routeSource': 'navBarProductDetailBack',
                            });
                            Mixpanel.track('goToShopPage', {
                              'routeSource': 'navBarProductDetailBack'
                            })
                            if (goBackFunction) {
                              goBackFunction();
                            } else {
                              history.goBack();
                            }
                          }}
                        >
                          <ArrowBack fontSize={isSmOrUp ? "medium" : "small"}/>
                        </IconButton>
                      </ScrollHandlerBarElementColor>
                    </Route>
                  </Switch>
                  <Box justifyContent="center" className={classes.titleLogoContainer} >
                    <ButtonBase component={RouterLink} to={categoryMap["SHOP"]}
                    onClick={() => {
                      dispatch(updateCurrentScreen("DEFAULT"));
                      (window as any).dataLayer.push({'event': 'navigateRoute', 'routePath': '/', 'routeSource': 'navBar'});
                      Mixpanel.track('navigateRoute', {
                        'routePath': '/',
                        'routeSource': 'navBar',
                      });  
                      Mixpanel.track('goToHomePage', {
                        'routeSource': 'navBar',
                      });
                      handleClickCategory();
                    }}
                    className={classes.titleLogoButtonBase}>
                      <ScrollHandlerLogo coloredAtTop={coloredAtTop} largerTitleAtTop={largerTitleAtTop} isSmOrUp={isSmOrUp} >
                        {
                          storeProfile?.config?.logoUrl ?
                          <img className={classes.titleLogo} src={storeProfile.config.logoUrl} alt="store logo"/> :
                          <Typography style={{fontSize: '19px', fontWeight: 700, letterSpacing: '1.5px', whiteSpace: 'nowrap', color: 'inherit'}} id='store-name-logo'>
                            {storeProfile?.name ?? ''}
                          </Typography>
                        }
                      </ScrollHandlerLogo>
                    </ButtonBase>
                  </Box>
                </Box>
              </Grid>
              {/* <Grid item justifyContent="center" xs={6} md={4} className={classes.sectionDesktopAndMobile}>
                <Box justifyContent="center" className={classes.titleLogoContainer} >
                  <ButtonBase component={RouterLink} to={categoryMap["HOME"]}
                  onClick={() => {
                    dispatch(updateCurrentScreen("DEFAULT"));
                    (window as any).dataLayer.push({'event': 'navigateRoute', 'routePath': '/', 'routeSource': 'navBar'});
                    Mixpanel.track('navigateRoute', {
                      'routePath': '/',
                      'routeSource': 'navBar',
                    });  
                    Mixpanel.track('goToHomePage', {
                      'routeSource': 'navBar',
                    });
                  }}>
                    <ScrollHandlerLogo coloredAtTop={coloredAtTop} largerTitleAtTop={largerTitleAtTop} isSmOrUp={isSmOrUp} >
                      <img className={classes.titleLogo} src={process.env.PUBLIC_URL + '/studios-wordmark-final.svg'} alt="maja logo"/>
                    </ScrollHandlerLogo>
                  </ButtonBase>
                </Box>
              </Grid> */}
              <Grid item xs={2} md={2}>
                <Box className={classes.sectionDesktopAndMobile}  justifyContent="flex-end">
                  <Switch>
                    {/* <Route path="/shop/product/:productId">

                    </Route> */}
                    {/* <Route>
                      <Box className={classes.sectionDesktopAndMobile} justifyContent="flex-start">
                        <div className={classes.buttonLinkContainer}>
                          <ScrollHandlerBarElementColor coloredAtTop={coloredAtTop} >
                            <Link component={RouterLink} to={categoryMap["SHOP"]} className={classes.buttonLink} 
                              onClick={() => {
                                (window as any).dataLayer.push({'event': 'navigateRoute', 'routePath': '/shop', 'routeSource': 'navBar'});
                                Mixpanel.track('navigateRoute', {
                                  'routePath': '/shop',
                                  'routeSource': 'navBar',
                                });
                                Mixpanel.track('goToShopPage', {
                                  'routeSource': 'navBar',
                                });
                              }}>
                              <Typography className={classes.shopText} onClick={handleClickCategory}>
                                SHOP
                              </Typography>
                            </Link>
                          </ScrollHandlerBarElementColor>
                        </div>
                      </Box>
                    </Route> */}
                  </Switch>
                  <Box className={classes.sectionDesktopAndMobile}>
                    <ScrollHandlerBarElementColor coloredAtTop={coloredAtTop} >
                      <IconButton 
                        className={classes.barIcon}
                        aria-label="account of current user"
                        component={RouterLink} to={categoryMap["YOUR ACCOUNT"]}
                        onClick={()=>{
                          (window as any).dataLayer.push({'event': 'navigateRoute', 'routePath': '/your-account', 'routeSource': 'navBar'});
                          Mixpanel.track('navigateRoute', {
                            'routePath': '/your-account',
                            'routeSource': 'navBar',
                          });
                          Mixpanel.track('goToAccountPage', {
                            'routeSource': 'navBar',
                          });
                        }}
                      >
                        <AccountCircleOutlinedIcon fontSize={isSmOrUp ? "medium" : "small"} />
                      </IconButton>
                    </ScrollHandlerBarElementColor>
                  </Box>

                  {
                    searchEnabled &&
                    <Box className={classes.sectionDesktopAndMobile}>
                      <ScrollHandlerBarElementColor coloredAtTop={coloredAtTop} >
                        <IconButton className={classes.barIcon} aria-label="search products"
                          id="tb-search-button" onClick={() => setSearchOpen(true)}>
                          <SearchIcon fontSize={isSmOrUp ? "medium" : "small"} />
                        </IconButton>
                      </ScrollHandlerBarElementColor>
                    </Box>
                  }
                  {
                    navMenuConfig.enabled && (navMenuConfig.items?.length ?? 0) > 0 &&
                    <Box className={classes.sectionDesktopAndMobile}>
                      <ScrollHandlerBarElementColor coloredAtTop={coloredAtTop} >
                        <IconButton
                          className={classes.barIcon}
                          aria-label="open menu"
                          id="tb-nav-menu-button"
                          onClick={(event) => setNavMenuAnchorEl(event.currentTarget)}
                        >
                          <MenuIcon fontSize={isSmOrUp ? "medium" : "small"} />
                        </IconButton>
                      </ScrollHandlerBarElementColor>
                      <Menu
                        id="tb-nav-menu"
                        anchorEl={navMenuAnchorEl}
                        keepMounted
                        open={Boolean(navMenuAnchorEl)}
                        onClose={() => { setNavMenuAnchorEl(null); setNavMenuOpenGroups({}); }}
                      >
                        {renderNavMenuEntries(navMenuConfig.items ?? [], '', 1)}
                      </Menu>
                    </Box>
                  }
                  {!isInsideIframe &&
                    <>
                  <ScrollHandlerBarElementColor coloredAtTop={coloredAtTop} >
                  <IconButton
                    className={classes.barIcon}
                    edge="end"
                    aria-label="open cart"
                    color="primary"
                    onClick={() => {
                      dispatch(updateCurrentScreen(navbarOverlayScreen === "CART" ? "DEFAULT" : "CART"));
                      (window as any).dataLayer.push({'event': 'navigateRoute', 'routePath': '/cart', 'routeSource': 'navBar'});
                      Mixpanel.track('navigateRoute', {
                        'routePath': '/cart',
                        'routeSource': 'navBar',
                      });
                      Mixpanel.track('cartOpen', {
                        'routeSource': 'navBar',
                      });
                    }}
                  >
                    <Badge badgeContent={numberOfItemsInCart} color="error">
                      <ShoppingCartOutlinedIcon fontSize={isSmOrUp ? "medium" : "small"} />
                    </Badge>
                  </IconButton>
                  </ScrollHandlerBarElementColor>
                    </>
                  }
                </Box>
              </Grid>
            </Grid>
          </Toolbar>

          {categoryNavEnabled &&
          <Route exact path={["/shop", "/shop/hero/:variantHero", "/shop/category/:categoryName", "/shop/landing", "/shop/start"]}>
            <div className={classes.productNavigation}>
              <div className={classes.productNavigationLeftSpacer}/>
              <Link className={classes.productNavigationContainer} color="inherit" component={RouterLink} to={semuaChipTarget}
              onClick={handleClickCategory}>
                <Switch>
                  <Route exact path={semuaChipSelectedPaths}>
                    <Box className={classes.productNavigationLinkTextContainerSelected}>
                      <Typography variant="body2" className={classes.productNavigationLinkTextSelected}>
                        SEMUA
                      </Typography>
                    </Box>
                  </Route>
                  <Route>
                    <Box className={classes.productNavigationLinkTextContainer}>
                      <Typography variant="body2" className={classes.productNavigationLinkText}>
                        SEMUA
                      </Typography>
                    </Box>
                  </Route>
                </Switch>
              </Link>
              {
                navCategories.map((navCategory) => (
                  <Link key={navCategory.handle} className={classes.productNavigationContainer} color="inherit" component={RouterLink}
                    to={"/shop/category/" + navCategory.handle}
                    onClick={handleClickCategory}>
                    <Switch>
                      <Route exact path={"/shop/category/" + navCategory.handle}>
                        <Box className={classes.productNavigationLinkTextContainerSelected}>
                          <Typography variant="body2" className={classes.productNavigationLinkTextSelected}>
                            {navCategory.title.toUpperCase()}
                          </Typography>
                        </Box>
                      </Route>
                      <Route>
                        <Box className={classes.productNavigationLinkTextContainer}>
                          <Typography variant="body2" className={classes.productNavigationLinkText}>
                            {navCategory.title.toUpperCase()}
                          </Typography>
                        </Box>
                      </Route>
                    </Switch>
                  </Link>
                ))
              }
              <div className={classes.productNavigationLeftSpacer}/>
            </div>
          </Route>}
        </AppBar>
      </ScrollHandlerAppBar>

      <SearchOverlay open={searchOpen} onClose={() => setSearchOpen(false)} />
      <MobileCategoryMenu navState={navbarOverlayScreen} />
      {
        isInsideIframe ? null : <CartWindow navState={navbarOverlayScreen} />
      }
    </div>
  );
}